// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_BLOGS = "Zp\u011bt na ze\u010f";
